







import Component from 'vue-class-component'
import MailingsLettersBatch from './MailingsLettersBatch.vue'
import MailingsStatementsBatch from './MailingsStatementsBatch.vue'
import { EBatchType } from '@zunta/configurations'
import Vue from 'vue'
import Card from '@/components/Card.vue'
import GoBack from '@/components/GoBack.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { StatementModule } from '@/store/modules/statement.module'
import { getModule } from 'vuex-module-decorators'
import { BatchModule } from '@/store/modules/batch.module'

@Component({
  components: { DateTimeLabel, GoBack, Card, MailingsStatementsBatch, MailingsLettersBatch }
})
export default class MailingsBatch extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  batchModuleInstance: BatchModule = getModule(BatchModule, this.$store)

  isLoading: boolean = true

  get batchID () {
    return this.$route.params.id
  }

  get selectedBatch () {
    return this.$store.state.batch.selectedBatch
  }

  get isStatementsBatch () {
    return this.selectedBatch && this.selectedBatch.type === EBatchType.STATEMENTS
  }

  get isLettersBatch () {
    return this.selectedBatch &&
        (this.selectedBatch.type === EBatchType.LETTERS || this.selectedBatch.type === EBatchType.COLLECTION_MAIL)
  }

  async mounted () {
    this.isLoading = true
    await this.batchModuleInstance.fetchBatch(this.batchID)
    this.isLoading = false
  }
}
